module.exports = __webpack_public_path__ + "img/logo_aas.02e8a389.png";